/* eslint-disable @next/next/no-img-element */
import { forwardRef, useEffect, useState, useRef } from "react";

const HeadingOne = forwardRef(({ children, ...props }, ref) => (
  <h1
    ref={ref}
    {...props}
    className="text-black text-sm xl:text-base font-semibold"
  >
    {children}
  </h1>
));
const HeadingTwo = forwardRef(({ children, ...props }, ref) => (
  <h2
    ref={ref}
    {...props}
    className="text-black font-medium text-xs xl:text-sm"
  >
    {children}
  </h2>
));

const Paragraph = forwardRef(({ children, ...props }, ref) => (
  <p
    ref={ref}
    {...props}
    className="text-black text-tiny xl:text-xs"
  >
    {children}
  </p>
));

// const Image = forwardRef(({ children, ...props }, ref) => (
//   <img
//     ref={ref}
//     {...props}
//     className="h-auto w-24 2xl:w-32"
//     src={props.src}
//     alt=""
//   />
// ));
const Image = forwardRef(({ children, ...props }, ref) => {
  const [isHorizontal, setIsHorizontal] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const imageElement = imageRef.current;

    if (imageElement) {
      const aspectRatio = imageElement.width / imageElement.height;
      setIsHorizontal(aspectRatio > 1);
    }
  }, [props.src]);

  return (
    <img
      ref={ref || imageRef}
      {...props}
      className={`${
        isHorizontal
          ? "object-contain h-20 md:h-24"
          : "h-auto w-20 md:w-24 2xl:w-32"
      } transform duration-300`}
      src={props.src}
      alt=""
    />
  );
});

const ImageLeft = forwardRef(({ children, ...props }, ref) => {
  const [isHorizontal, setIsHorizontal] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const imageElement = imageRef.current;

    if (imageElement) {
      const aspectRatio = imageElement.width / imageElement.height;
      setIsHorizontal(aspectRatio > 1);
    }
  }, [props.src]);

  return (
    <img
      ref={ref || imageRef}
      {...props}
      className={`${
        isHorizontal
          ? "object-contain object-left h-24"
          : "h-auto w-24 2xl:w-32"
      } transform duration-300`}
      src={props.src}
      alt=""
    />
  );
});

const ImageRight = forwardRef(({ children, ...props }, ref) => {
  const [isHorizontal, setIsHorizontal] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const imageElement = imageRef.current;

    if (imageElement) {
      const aspectRatio = imageElement.width / imageElement.height;
      setIsHorizontal(aspectRatio > 1);
    }
  }, [props.src]);

  return (
    <img
      ref={ref || imageRef}
      {...props}
      className={`${
        isHorizontal
          ? "object-contain object-right h-24"
          : "h-auto w-24 2xl:w-32"
      } transform duration-300`}
      src={props.src}
      alt=""
    />
  );
});

HeadingOne.displayName = "HeadingOne";
HeadingTwo.displayName = "HeadingTwo";
Paragraph.displayName = "Paragraph";
Image.displayName = "Image";
ImageLeft.displayName = "Image Left";
ImageRight.displayName = "Image Right";

export { HeadingOne, HeadingTwo, Paragraph, Image, ImageLeft, ImageRight };
